import styled from 'styled-components'
import { themeGet } from 'styled-system'
import {
  TextAreaWithCharacterCounterError,
  TextAreaWithCharacterCounter,
  WarningIcon,
} from 'secondstep-components'
import AccessibleTextLink from 'components/AccessibleTextLink'

export const AddGoalButton = styled.button`
  display: flex;
  align-items: center;
  background: none;
  border: none;
  font-family: ${themeGet('font.molde.medium')};
  font-size: 1rem;
  color: ${themeGet('colors.blue')};
  cursor: pointer;
  align-self: flex-start;
  line-height: 0.75rem;
  padding-left: 0;

  svg {
    margin-right: 0.5rem !important;
    margin-bottom: 0.125rem;
  }

  &:hover {
    text-decoration: underline;
  }
`

export const Error = styled.div`
  display: flex;
  align-items: baseline;
  text-align: left;
  font-size: 0.75rem;
  margin-top: 0.375rem;
  color: ${themeGet('colors.errorRed')};
`

export const ErrorText = styled.span`
  line-height: 0.9375rem;
  font-family: ${themeGet('font.molde.medium')};
`

export const GoalTextLabel = styled.label`
  font-family: ${themeGet('font.sharpSlab.semibold')};
  font-size: 1rem;
  color: ${themeGet('colors.darkBlue')};
`

export const HeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`

export const InputLabel = styled.label`
  font-size: 0.75rem;
  font-family: ${themeGet('font.molde.medium')};
  color: ${themeGet('colors.darkGray')};
`

export const OptionalBadge = styled.div`
  background-color: ${themeGet('colors.white')};
  border-radius: 0.625rem;
  font-family: ${themeGet('font.molde.medium')};
  font-color: ${themeGet('colors.darkGray')};
  font-size: 0.75rem;
  margin-left: 0.5rem;
  padding: 0 0.5rem;
`

export const OptionalGoalsContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 1.25rem 0;

  [class*='StyledCalendarInput'] {
    width: 275px;
  }
`

export const OptionalGoalWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0.9375rem 1.375rem 1.25rem;
  background-color: ${themeGet('colors.paleGray')};
  border-radius: 0.625rem;
  position: relative;
  margin-bottom: 1.25rem;
`

export const RemoveGoalLink = styled(AccessibleTextLink)`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: none;
  border: none;
  font-family: ${themeGet('font.molde.medium')};
  font-size: 1rem;
  color: ${themeGet('colors.blue')};
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`

export const StyledHr = styled.hr`
  width: 100%;
  height: 2px;
  border: none;
  margin: 0.75rem 0 0.9375rem;
  background-color: ${themeGet('colors.white')};
`

export const StyledTextAreaWithCharacterCounter = styled(
  TextAreaWithCharacterCounter,
)`
  margin-bottom: -0.8125rem;

  ${TextAreaWithCharacterCounterError} {
    margin-bottom: 1.125rem;
  }
`

export const StyledWarningIcon = styled(WarningIcon)`
  height: 9px;
  width: 9px;
  margin-right: 0.25rem;

  circle:first-child {
    fill: ${themeGet('colors.errorRed')};
  }
`

export const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
`
